import React from 'react';
import { Accordion } from 'react-bootstrap';
import { Button, Card, Col, Row } from 'react-bootstrap';

const SupportFAQ = () => {
  return (
    <Card className="h-100">
      <Card.Body className="d-flex flex-column">
        <Card.Title className="fs-6 fw-bold text-center text-md-start">
          Frequently Asked Questions
        </Card.Title>
        <Row className="w-100 mt-1 gx-4 gy-4">
          <Col
            lg={5}
            xs={12}
            className="d-flex flex-column text-center text-lg-start"
          >
            <div>
              Hundreds of companies trust CRUDBeat to connect with top talent in
              technology and engineering:
            </div>
            <div className="d-flex justify-content-center justify-content-lg-start mt-3">
              <Button variant="secondary">Contact Our Team</Button>
            </div>
          </Col>
          <Col lg={7} xs={12}>
            <Row className="gx-4 gy-3">
              <Col lg={12} xs={12}>
                <div className="d-flex flex-column gap-3">
                  <div className="fw-semibold">What is CRUDBeat?</div>
                  <div>
                    CRUDBeat provides tailored resources, sample questions, and
                    practice tests to help you sharpen your skills. Focus on
                    completing assessments in your area of expertise and track
                    your progress through personalized feedback and real-time
                    performance insights.{' '}
                  </div>
                </div>
              </Col>
              <Col lg={12} xs={12} className="mt-4">
                <Accordion defaultActiveKey="0">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header className="text-secondary">
                      How can CRUDBeat help me get a job?
                    </Accordion.Header>
                    <Accordion.Body className="pt-0">
                      CRUDBeat connects students directly with top recruiters
                      and organizations. By showcasing your skills through
                      assessments, tech challenges, and a standout profile, you
                      gain visibility to hiring managers actively looking for
                      talent like yours.
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="1">
                    <Accordion.Header>
                      What kind of opportunities does CRUDBeat provide?
                    </Accordion.Header>
                    <Accordion.Body className="pt-0">
                      CRUDBeat offers a range of opportunities including
                      participation in tech challenges, webinars, events, and
                      workshops. These not only help you learn and grow but also
                      allow you to earn recognition and money while building
                      your professional network.
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="2">
                    <Accordion.Header>
                      How can I prepare for assessments on CRUDBeat?
                    </Accordion.Header>
                    <Accordion.Body className="pt-0">
                      CRUDBeat provides tailored resources, sample questions,
                      and practice tests to help you sharpen your skills. Focus
                      on completing assessments in your area of expertise and
                      track your progress through personalized feedback and
                      real-time performance insights.
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </Col>
            </Row>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default SupportFAQ;
